export var OrderRegisterStatusType;
(function (OrderRegisterStatusType) {
    OrderRegisterStatusType["failed"] = "failed";
    OrderRegisterStatusType["success"] = "success";
    OrderRegisterStatusType["successSubsequent"] = "success_subsequent";
    OrderRegisterStatusType["skipped"] = "skipped";
    OrderRegisterStatusType["einvoiceSent"] = "einvoice-sent";
    OrderRegisterStatusType["einvoiceSending"] = "einvoice-sending";
    OrderRegisterStatusType["einvoiceApproved"] = "einvoice-approved";
    OrderRegisterStatusType["einvoiceRejected"] = "einvoice-rejected";
    OrderRegisterStatusType["einvoiceCancelled"] = "einvoice-cancelled";
    OrderRegisterStatusType["einvoiceStorno"] = "einvoice-storno";
    OrderRegisterStatusType["einvoicePaid"] = "einvoice-paid";
    OrderRegisterStatusType["einvoiceNew"] = "einvoice-new";
    OrderRegisterStatusType["einvoiceSeen"] = "einvoice-seen";
    // Stored as aria-api sends it: SEF's "Mistake" carries no einvoice- prefix.
    OrderRegisterStatusType["einvoiceMistake"] = "mistake";
})(OrderRegisterStatusType || (OrderRegisterStatusType = {}));
export var OrderFlagType;
(function (OrderFlagType) {
    OrderFlagType["ref"] = "ref";
    OrderFlagType["type"] = "type";
    OrderFlagType["guest"] = "guest";
    OrderFlagType["reason"] = "reason";
    OrderFlagType["advance"] = "advance";
    /** Room charge (hotel PMS). The 'otaSync' VALUE is frozen — it is
     *  persisted in years of order rows and written by deployed builds
     *  (the provider's former company name). */
    OrderFlagType["roomCharge"] = "otaSync";
    OrderFlagType["timeout"] = "timeout";
    OrderFlagType["pricelist"] = "pricelist";
    OrderFlagType["discountPercent"] = "discountPercent";
    OrderFlagType["separator"] = "separator";
    OrderFlagType["correctType"] = "correctType";
    /** `corrected,partial`: written on an order beside canceled_at when a partial correction
     *  (correctType correct / correctSummary) stamps it — locked, not cancelled; a partly corrected
     *  table bill still pays its rounds (Order.paidByOrder). The server writes the same. */
    OrderFlagType["corrected"] = "corrected";
    OrderFlagType["mode"] = "mode";
    OrderFlagType["clearDebtForUser"] = "clearDebtForUser";
    OrderFlagType["tableTransfer"] = "tableTransfer";
    OrderFlagType["qrOrder"] = "qrOrder";
    OrderFlagType["deliveryPayment"] = "deliveryPayment";
    OrderFlagType["calloutCode"] = "calloutCode";
    /** Platform's own order reference (courier-facing), snapshotted from
     *  OrderTicket.external_code at completeAndIssue. Distinct from
     *  calloutCode, which is the internal staff identifier. API tickets only. */
    OrderFlagType["externalCode"] = "externalCode";
})(OrderFlagType || (OrderFlagType = {}));
[];
//# sourceMappingURL=defOrder.js.map